import { render, staticRenderFns } from "./QueryLogDetailsHeader.vue?vue&type=template&id=364de3cd&scoped=true&"
import script from "./QueryLogDetailsHeader.vue?vue&type=script&lang=js&"
export * from "./QueryLogDetailsHeader.vue?vue&type=script&lang=js&"
import style0 from "./QueryLogDetailsHeader.vue?vue&type=style&index=0&id=364de3cd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364de3cd",
  null
  
)

export default component.exports